<template>
    <div class="pa-4">
        <h1 class="mb-5 text--xl font-weight-medium">{{ $t('navigation.object_groups') }}</h1>

        <SitesGroupsTable @change-page="changePage($event)"
                          @change-amount="changeAmount($event)"
                          @sort="sortingColumn = $event"
                          @fetch="fetchSitesGroups"
                          :loader="loader"
                          :changed-page="pagination.page"></SitesGroupsTable>

        <ManageSitesGroup @fetch="fetchSitesGroups"></ManageSitesGroup>
    </div>
</template>

<script>
import SitesGroupsTable from '@/components/sitesGroups/SitesGroupsTable';
import ManageSitesGroup from '@/components/sitesGroups/manageSitesGroup/ManageSitesGroup';

export default {
    name: 'SitesGroupsConfigurations',
    components: { SitesGroupsTable, ManageSitesGroup },
    data: () => ({
        loader: false,
        pagination: {
            page: 1,
            amount: 20
        },
        sortingColumn: null
    }),
    watch: {
        sortingColumn: {
            handler () {
                this.fetchSitesGroups();
            },
            deep: true
        }
    },
    methods: {
        fetchSitesGroups () {
            this.loader = true;

            const params = {
                'page': this.pagination.page,
                'page_size': this.pagination.amount
            };

            if (this.sortingColumn) {
                params.ordering = this.sortingColumn.value === 'asc' ? this.sortingColumn.name : `-${this.sortingColumn.name}`;
            }

            this.$store.dispatch('sites/getSiteGroups', params)
                .finally(() => {
                    this.loader = false;
                });
        },
        changePage (event) {
            this.pagination.page = event;
            this.fetchSitesGroups();
        },
        changeAmount (event) {
            this.pagination.page = 1;
            this.pagination.amount = event;
            this.fetchSitesGroups();
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            if (vm.$can(vm.$abilityActions.READ, vm.$abilitySubjects.SITE_GROUP)) {
                vm.fetchSitesGroups();
            } else {
                vm.$router.push({ name: 'home' });
            }
        });
    }
};
</script>

<style scoped>

</style>
